


class AddBillboard {
    constructor() {
        this.groups = []
    }
    addGroup(id, positions, properties, urls) {
        const g = this.getById(id)
        if (g) {
            this.setShowById(id)
        } else {
            const group = { id: id, containers: [] }
            this.groups.push(group)
            for (let i = 0; i <= positions.length - 1; i++) {
                const polygon = this.addBillboard(positions[i], properties[i], urls[i])
                group.containers.push(polygon)
            }
        }
    }
    addBillboard(position, properties = {}, url) {
        const billboard = new map3d.Entity.Billboard({
            pix: 1000,
            properties: properties,
            height: 100,
            id: properties.id,
            width: 100,
            offset: [0, -30],
            eyeOffset: [0, 0, -100],
            position: position,
            url: url,
            clampToGround: true,
        })
        billboard.clampToTerrain()
        return billboard
    }
    getById(id) {
        let result
        this.groups.forEach((item) => {
            if (item.id === id) {
                result = item
            }
        })
        return result
    }
    setShowById(id, show) {
        const polygongroup = this.getById(id)
        polygongroup.containers.forEach((item) => {
            item.setShow(show)
        })
    }
}
export default new AddBillboard()




// WEBPACK FOOTER //
// ./src/mapfunction/AddBillboard.js